import { Component, OnInit, Input } from '@angular/core';

import { getParams } from '@app/shared/utils/utils.object';
import { ConfigService } from '@app/core/config.service';
import { cachedPath } from '@app/shared/components/syndicated-layout/syndicated-options';
import { SYNDICATED_FOOTER_ANIMATIONS } from '@app/shared/components/syndicated-layout/syndicated-footer/syndicated-footer.animations';

@Component({
    selector: 'syndicated-footer',
    templateUrl: './syndicated-footer.component.html',
    styleUrls: ['./syndicated-footer.component.scss'],
    animations: [...SYNDICATED_FOOTER_ANIMATIONS]
})
export class SyndicatedFooterComponent implements OnInit {
    @Input() url: string;
    @Input() siteId: string;
    @Input() version: number;
    @Input() locale: string;
    @Input() language: string;
    @Input() environment: string;

    syndicatedFooterUrl: string;
    baseURL: string;
    footerOptions: object;
    syndicatedLayoutOptions: any;
    useCached = false; // @TODO validate if the user is not loggedIn to use cache.
    stateName: string;
    showLine = false;

    constructor(
        private configService: ConfigService
    ) { }

    ngOnInit() {
        this.syndicatedLayoutOptions = this.configService.getValue('syndicatedLayout');
        this.baseURL = this.syndicatedLayoutOptions.baseURL;
        this.footerOptions = this.syndicatedLayoutOptions.footer;
        this.syndicatedFooterUrl = `${this.baseURL}/footer${this.useCached ? cachedPath : '/'}${getParams(this.footerOptions)}`;
        this.stateName = 'loaded';
    }

    footerStateDone(event: AnimationEvent) {
        this.showLine = true;
        // We want to make sure that the animation is complete and the style has been set
        // by the animation module. Once that is done we can manually remove the style attr.
        setTimeout(() => {
            event['element'].removeAttribute('style');
        });
    }
}
